module.exports = __webpack_public_path__ + "assets/img/plane_gray.svg";